import {CodebookModel} from '../models/codebook.model';

export class ThematicGroupTypeCodebook {
    static allTypes:CodebookModel[] = [
        {
            id:1,
            name:'ThematicGroupType-Všeobecné'
        },{
            id:2,
            name:'ThematicGroupType-Filozofia, psychológia'
        },{
            id:3,
            name:'ThematicGroupType-Náboženstvo, teológia'
        },{
            id:4,
            name:'ThematicGroupType-Sociológia, štatistika'
        },{
            id:5,
            name:'ThematicGroupType-Politika, ekonómia'
        },{
            id:6,
            name:'ThematicGroupType-Právo, verejná správa, soc. zabezp. a soc. starostlivosť, poisťovníctvo'
        },{
            id:7,
            name:'ThematicGroupType-Vojenské umenie a vojenská veda'
        },{
            id:8,
            name:'ThematicGroupType-Školstvo, pedagogika, voľný čas'
        },{
            id:9,
            name:'ThematicGroupType-Obchod, spoje, doprava, cestov. ruch'
        },{
            id:10,
            name:'ThematicGroupType-Etnografia, kultúrna antropológia'
        },{
            id:11,
            name:'ThematicGroupType-Filológia, jazyky, jazykoveda'
        },{
            id:12,
            name:'ThematicGroupType-Matematika'
        },{
            id:13,
            name:'ThematicGroupType-Prírodné vedy'
        },{
            id:14,
            name:'ThematicGroupType-Lekárske vedy, zdravotníctvo'
        },{
            id:15,
            name:'ThematicGroupType-Priemysel, technika, technológia, stavebníctvo, obchod a remeslá'
        },{
            id:16,
            name:'ThematicGroupType-Poľnohospodárstvo, lesníctvo, chov dobytka, lov zveri a rybolov'
        },{
            id:17,
            name:'ThematicGroupType-Domáce hospodárstvo'
        },{
            id:18,
            name:'ThematicGroupType-Manažment, riadenie a organizácia'
        },{
            id:19,
            name:'ThematicGroupType-Územné plánovanie, urbanizmus a tvorba krajiny, architektúra a tvorba krajiny'
        },{
            id:20,
            name:'ThematicGroupType-Sochárstvo, výtvarné umenie, grafika, fotografia'
        },{
            id:21,
            name:'ThematicGroupType-Hudba, divadlo, film, umenie'
        },{
            id:22,
            name:'ThematicGroupType-Hry a šport'
        },{
            id:23,
            name:'ThematicGroupType-Dejiny literatúry a literárna kritika'
        },{
            id:24,
            name:'ThematicGroupType-Literárne texty (beletria)'
        },{
            id:25,
            name:'ThematicGroupType-Geografia'
        },{
            id:26,
            name:'ThematicGroupType-História, životopisy'
        }
    ];
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/codebook/thematic-group-type-codebook.ts